import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { HeartRateAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-measure-heartrate-slot',
    templateUrl: './measure-heartrate-slot.component.html',
    styleUrl: './measure-heartrate-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeartRateSlotComponent implements SheetSlotComponentBase {

	action!: HeartRateAction;
	value!: string | null;

	@Input('action') set updateAction(action: HeartRateAction | null) {
		this.action = action as HeartRateAction;
		this.value = this.action.beatsPerMinute?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}